// @generated by protoc-gen-es v2.9.0 with parameter "import_extension=js"
// @generated from file services/source/api/source_artifact.proto (package gx.source.api, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_services_database_models_public } from "../../database/models/public_pb.js";
import { file_services_source_resources_source_artifact } from "../resources/source_artifact_pb.js";
import { file_shared_pagination } from "../../../shared/pagination_pb.js";
import { file_shared_sorting } from "../../../shared/sorting_pb.js";

/**
 * Describes the file services/source/api/source_artifact.proto.
 */
export const file_services_source_api_source_artifact = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_services_database_models_public, file_services_source_resources_source_artifact, file_shared_pagination, file_shared_sorting]);

/**
 * Describes the message gx.source.api.CreateSourceArtifactRequest.
 * Use `create(CreateSourceArtifactRequestSchema)` to create a new message.
 */
export const CreateSourceArtifactRequestSchema = /*@__PURE__*/
  messageDesc(file_services_source_api_source_artifact, 0);

/**
 * Describes the message gx.source.api.CreateSourceArtifactResponse.
 * Use `create(CreateSourceArtifactResponseSchema)` to create a new message.
 */
export const CreateSourceArtifactResponseSchema = /*@__PURE__*/
  messageDesc(file_services_source_api_source_artifact, 1);

/**
 * Describes the message gx.source.api.GetSourceArtifactRequest.
 * Use `create(GetSourceArtifactRequestSchema)` to create a new message.
 */
export const GetSourceArtifactRequestSchema = /*@__PURE__*/
  messageDesc(file_services_source_api_source_artifact, 2);

/**
 * Describes the message gx.source.api.GetSourceArtifactResponse.
 * Use `create(GetSourceArtifactResponseSchema)` to create a new message.
 */
export const GetSourceArtifactResponseSchema = /*@__PURE__*/
  messageDesc(file_services_source_api_source_artifact, 3);

/**
 * Describes the message gx.source.api.ListSourceArtifactsRequest.
 * Use `create(ListSourceArtifactsRequestSchema)` to create a new message.
 */
export const ListSourceArtifactsRequestSchema = /*@__PURE__*/
  messageDesc(file_services_source_api_source_artifact, 4);

/**
 * Describes the message gx.source.api.ListSourceArtifactsResponse.
 * Use `create(ListSourceArtifactsResponseSchema)` to create a new message.
 */
export const ListSourceArtifactsResponseSchema = /*@__PURE__*/
  messageDesc(file_services_source_api_source_artifact, 5);

/**
 * Describes the message gx.source.api.DeleteSourceArtifactRequest.
 * Use `create(DeleteSourceArtifactRequestSchema)` to create a new message.
 */
export const DeleteSourceArtifactRequestSchema = /*@__PURE__*/
  messageDesc(file_services_source_api_source_artifact, 6);

/**
 * Describes the message gx.source.api.DeleteSourceArtifactResponse.
 * Use `create(DeleteSourceArtifactResponseSchema)` to create a new message.
 */
export const DeleteSourceArtifactResponseSchema = /*@__PURE__*/
  messageDesc(file_services_source_api_source_artifact, 7);

/**
 * Describes the message gx.source.api.DownloadSourceArtifactRequest.
 * Use `create(DownloadSourceArtifactRequestSchema)` to create a new message.
 */
export const DownloadSourceArtifactRequestSchema = /*@__PURE__*/
  messageDesc(file_services_source_api_source_artifact, 8);

/**
 * Describes the message gx.source.api.DownloadSourceArtifactResponse.
 * Use `create(DownloadSourceArtifactResponseSchema)` to create a new message.
 */
export const DownloadSourceArtifactResponseSchema = /*@__PURE__*/
  messageDesc(file_services_source_api_source_artifact, 9);

/**
 * @generated from service gx.source.api.SourceArtifactService
 */
export const SourceArtifactService = /*@__PURE__*/
  serviceDesc(file_services_source_api_source_artifact, 0);

